module.exports = __webpack_public_path__ + "0dad47d4a86eee8e2406ab094280c346.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/prize_5.png
// module id = 115
// module chunks = 0